import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAllVendorMedSettlementSurgery } from '../../../store/actions';
import Settlements from './Settlements';

const mapStateToProps = ({ medicalReducer }) => ({
  results: medicalReducer.results,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllVendorMedSettlementSurgery,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Settlements);
